<!--
移动端：选择组件。pupop+picker

<template>
  <div>
    <el-button @click="visible = true">{{name}}</el-button>
    <m-picker v-model="value" :visible.sync="visible" title="select" show-toolbar :columns="columns" :customField="{value: 'id', label: 'name'}" @confirm="confirm"></m-picker>
  </div>
</template>

<script>
import Picker from '@/components/mobile/Picker.vue'
export default {
  components: { 'm-picker': Picker },
  data() {
    return {
      value: 3,
      visible: false,
      columns: [
        { id: 1, name: 'jack' },
        { id: 2, name: 'tom' },
        { id: 3, name: 'bob' }
      ]
    }
  },
  methods: {
    confirm(value, row) {}
  }
}
</script>
-->

<template>
  <div class="mobile-select f-b" @click.self="visible = true">
    <span :class="{requiredLabel: isRequired}">{{text}}</span>
    <i class="iconfont icon-jiantou-xuanze" />
    <m-picker v-bind="$attrs" :value="value" :visible.sync="visible" show-toolbar :columns="columns" :customField="customField" @confirm="confirm" />
  </div>
</template>

<script>
import Picker from '@/components/mobile/Picker.vue'

export default {
  components: { 'm-picker': Picker },
  model: {
    prop: 'value',
    event: 'valueChange'
  },
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    columns: {
      type: Array,
      default: () => []
    },
    customField: {
      type: Object,
      default: () => ({ label: 'label', value: 'value' })
    },
    placeholder: {
      type: String,
      default: 'Select'
    },
    isRequired: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    text() {
      const column = this.columns.find(item => item[this.customField.value] === this.value)
      return column ? column[this.customField.label] : this.placeholder
    }
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    confirm(value, item) {
      this.$emit('valueChange', value)
      this.$emit('change', value, item)
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-select{
  font-size: .28rem;
  width: 100%;
  height: 1rem;
  line-height: 1rem;
  // padding: 0 .3rem;
  i{
    font-size: .28rem;
  }
  >span{
      color: gray;
  }
}
.requiredLabel::before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
}
</style>
